module.exports = "/_next/static/files/dbad0a43b1f1fd4b506bcff4a3018386.png";